import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import LoginForm from './LoginForm';

const ProtectedRoute = ({ children, requireAdmin = true }) => {
  const { isAuthenticated, isAdmin, loading, user } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // Check if user is authenticated
  if (!isAuthenticated()) {
    return <LoginForm />;
  }

  // Check if admin access is required
  if (requireAdmin && !isAdmin()) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cinema-ivory">
        <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full mx-4 border border-gray-200">
          <div className="text-center">
            <div className="mb-4">
              <svg className="mx-auto h-12 w-12 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Insufficient Permissions</h2>
            <p className="text-gray-600 mb-2">
              You don't have admin privileges to access this page.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Logged in as: <span className="text-cinema-red font-medium">{user?.username}</span>
            </p>
            <button 
              onClick={() => window.location.href = '/'}
              className="bg-cinema-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded transition-colors"
            >
              Go to Homepage
            </button>
          </div>
        </div>
      </div>
    );
  }

  // User is authenticated and has required permissions
  return children;
};

export default ProtectedRoute;